import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAutoSave, SaveStatus } from "@/lib/useAutoSave";

export const PlanPricesEditor = () => {
  const [plans, setPlans] = useState(null);
  const [vals, setVals] = useState({});
  const load = (list) => { setPlans(list); setVals(Object.fromEntries(list.map((p) => [p.id, String(p.amount)]))); };
  useEffect(() => { api.get("/billing/plans").then((r) => load(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);

  const save = async (v) => {
    const amounts = Object.fromEntries(Object.entries(v).map(([k, x]) => [k, Number(x)]));
    if (plans.every((p) => amounts[p.id] === p.amount)) return;
    const bad = Object.values(amounts).some((n) => !(n >= 1 && n <= 10000));
    if (bad) throw new Error("Prices must be between $1 and $10,000");
    const { data } = await api.put("/admin/plans", { amounts });
    load(data);
    toast.success("Plan prices saved and updated in Stripe");
  };
  const auto = useAutoSave(vals, save);

  if (!plans) return <div className="loader-bar" />;
  return (
    <div className="space-y-5" data-testid="plan-prices-editor" onBlurCapture={auto.onBlurCapture}>
      <p className="text-sm text-slate-400 max-w-2xl">Prices in AUD. Each price saves as soon as you leave its box, updating the Subscribe page, the cover page and Stripe checkout straight away. Passes already bought are not changed.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {plans.map((p) => (
          <label key={p.id} className="panel p-4 flex flex-col gap-2">
            <span className="eyebrow">{p.label.includes("days") ? p.label : `${p.label} • ${p.days} days`}</span>
            <span className="flex items-center gap-1 text-lg text-white">$
              <input type="number" min={1} max={10000} step="0.01" value={vals[p.id] ?? ""} data-testid={`plan-price-input-${p.id}`}
                onChange={(e) => { auto.markDirty(); setVals({ ...vals, [p.id]: e.target.value }); }}
                onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
                className="w-28 bg-[#0F172A] border border-slate-700 rounded px-2 py-1 num focus:border-emerald-500 outline-none" />
            </span>
          </label>
        ))}
      </div>
      <SaveStatus status={auto.status} onRetry={() => { auto.markDirty(); auto.flush(); }} testId="plan-prices-save" />
    </div>
  );
};
